const BASE_TEST_ID = 'collapsible-filter';

export const COLLAPSIBLE_FILTER_GROUP_TEST_IDS = {
    base: BASE_TEST_ID,
    group: `${BASE_TEST_ID}-group`,
    label: `${BASE_TEST_ID}-label`,
    chips: `${BASE_TEST_ID}-chips`,
    toggle: `${BASE_TEST_ID}-toggle`,
};
